import { useQueryClient } from '@tanstack/react-query';
import { readAuthToken } from '@noor/api';
import { useAdminSocket } from '@/shared/lib/admin-socket';
import { ordersKeys } from '@/entities/order';
import { useChatRealtime } from '@/features/conversation-actions';
import { ROLES, useCurrentRole } from '@/entities/session';
import { SearchAlarmMonitor } from '@/app/search-alarm/search-alarm-monitor';

/**
 * App-wide services that run for a signed-in session, mounted inside the
 * authenticated chrome (never on the sign-in screen) — cpanel's
 * `WebSocketProvider` + `SearchAlarmLayer`:
 * - the admin socket: a `refresh` push refetches the orders lists, which is
 *   what keeps an open orders page live, and the chat pushes keep the support
 *   inbox live (new messages, hand-over offers, status changes, read ticks);
 * - the night search alarm, armed for CALL_CENTER operators only.
 */
export function SessionServices() {
  const queryClient = useQueryClient();
  const role = useCurrentRole();
  const hasToken = Boolean(readAuthToken());

  const onChatEvent = useChatRealtime(role);

  useAdminSocket({
    enabled: hasToken,
    onRefresh: () => void queryClient.invalidateQueries({ queryKey: ordersKeys.all }),
    onChatEvent,
    onOffer: (content) =>
      queryClient.setQueryData(['order-courier-offer'], { ...content, time: Date.now() }),
  });

  return <SearchAlarmMonitor enabled={hasToken && role === ROLES.CALL_CENTER} />;
}
